import { ETheme } from "@/DependenciesV9";
import { NavDrawerHeader, NavDrawerHeaderProps } from "@fluentui/react-nav-preview";

interface NavDrawerHeaderCustomProps extends NavDrawerHeaderProps {
  rcName?: string;
  theme?: ETheme;
}

const NavDrawerHeaderCustom = (props: NavDrawerHeaderProps & NavDrawerHeaderCustomProps) => {
  return <NavDrawerHeader {...props}/>
};

export default NavDrawerHeaderCustom;